import React, { useState } from 'react';
import styled from 'styled-components';
import { colours, H1, H2, HR, isMobile } from '@sorted/sorted-ui';
import LandingPageCards from '../../components/LandingPageCards';

const Div = styled.div`
	margin: 87px 50px;
`;

const Button = styled.button`
	border: 0;
	appearance: none;
	background: transparent;
	margin: 0;
	padding: 0;
`;

const H1Styled = styled(H1)`
	margin: 0;
	line-height: 1;
	display: flex;
	justify-items: center;
`;

const H2Styled = styled(H2)`
	margin: 0px 0 30px 0;
	color: ${colours.pink};
`;

const HRStyled = styled(HR)`
	margin: 0px 0 30px 0;
`;

const Spacing = styled.div`
	display: flex;
	justify-content: space-between;
`;

const MegaphonePath =
	'M544 184.88V32.01C544 23.26 537.02 0 512.01 0H512c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64l-.48 32c0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h106.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13c19.05-11.09 32-31.49 32-55.12.01-23.64-12.94-44.04-31.99-55.13zM127.73 464c-10.76-25.45-16.21-52.31-16.21-80 0-14.22 1.72-25.34 2.6-32h64.91c-2.09 10.7-3.52 21.41-3.52 32 0 28.22 6.58 55.4 19.21 80h-66.99zM240 304H64c-8.82 0-16-7.18-16-16v-96c0-8.82 7.18-16 16-16h176v128zm256 110.7l-59.04-47.24c-42.8-34.22-94.79-55.37-148.96-61.45V173.99c54.17-6.08 106.16-27.23 148.97-61.46L496 65.3v349.4z';

const Landing = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);

	const SVG = () => (
		<svg
			width="24"
			aria-hidden="true"
			focusable="false"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 576 512"
		>
			<path fill="#000" d={MegaphonePath} />
		</svg>
	);

	return (
		<>
			<Div>
				<Spacing>
					<H1Styled>Hello</H1Styled>
					{isMobile() && (
						<Button onClick={() => setDrawerOpen(!drawerOpen)}>
							<SVG />
						</Button>
					)}
				</Spacing>
				<H2Styled>Let&apos;s get things Sorted</H2Styled>
				<HRStyled />
				<LandingPageCards
					toggleOpen={setDrawerOpen}
					drawerOpen={drawerOpen}
				/>
			</Div>
		</>
	);
};

export default Landing;
